/* Videoguys V2 dispatch rules. Shared by the admin preview and storefront. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.VideoguysDispatchV2 = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function nextDispatch(calendar, instant = new Date()) {
    if (!calendar || calendar.version !== 2 || !calendar.enabled) return null;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(calendar.reviewedThrough || '') || !Array.isArray(calendar.week) || calendar.week.length !== 7 || !Array.isArray(calendar.holidays)) return null;
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-AU', {
      timeZone: calendar.timezone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(instant).map(p => [p.type, p.value]));
    const today = `${parts.year}-${parts.month}-${parts.day}`;
    const time = `${parts.hour}:${parts.minute}`;
    // UTC is only used for date arithmetic. Local time comes from the named timezone.
    const date = new Date(`${today}T12:00:00Z`);
    const start = calendar.sameDay ? 0 : 1;
    date.setUTCDate(date.getUTCDate() + start);
    for (let offset = start; offset < 370; offset++, date.setUTCDate(date.getUTCDate() + 1)) {
      const iso = date.toISOString().slice(0, 10);
      if (iso > calendar.reviewedThrough) return null;
      const day = calendar.week[date.getUTCDay()];
      if (!day || !day.open || !day.dispatch) continue;
      if (calendar.holidays.some(h => h.active && h.start <= iso && h.end >= iso)) continue;
      if (iso === today && (time >= day.close || time >= calendar.cutoff)) continue;
      return {date: iso, today: iso === today, label: new Intl.DateTimeFormat('en-AU', {
        timeZone: 'UTC', weekday: 'long', month: 'short', day: 'numeric'
      }).format(date)};
    }
    return null;
  }
  return {nextDispatch};
});
